import { render, staticRenderFns } from "./HomeFaq.vue?vue&type=template&id=7cb19e70&"
import script from "./HomeFaq.vue?vue&type=script&lang=js&"
export * from "./HomeFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports